export default "__VITE_ASSET__cbUuAbg1__"